jQuery(document).ready(function ($) {
	if ($(".scroll-icon")) {
		$(".scroll-icon").on("click", () => {
			scroll(document.querySelector(".second-section"));
		});
	}
});
